import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Radio, Users } from "lucide-react";
import { api, imgUrl } from "@/lib/api";

export default function Live() {
  const { data: sessions = [], isLoading } = useQuery({
    queryKey: ["live-sessions"],
    queryFn: async () => (await api.get("/live/sessions")).data,
    refetchInterval: 8000,
  });

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-28 pb-24">
      <div className="flex items-center gap-2 text-[11px] tracking-luxe uppercase text-aura-accent mb-3">
        <span className="w-2 h-2 rounded-full bg-aura-accent animate-pulse" /> Live now
      </div>
      <h1 className="font-serif text-5xl tracking-tight mb-3">Live selling</h1>
      <p className="text-sm text-aura-muted max-w-lg mb-12">
        Sellers broadcasting in real time — watch, chat and shop the drop as it happens.
      </p>

      {isLoading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array.from({ length: 3 }).map((_, i) => <div key={i} className="aspect-video shimmer rounded-xl" />)}
        </div>
      ) : sessions.length === 0 ? (
        <div className="py-20 text-center text-aura-muted">
          No one is live right now. Sellers can start a broadcast from their studio.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="live-sessions">
          {sessions.map((s) => (
            <Link key={s.id} to={`/live/${s.id}`} className="group relative aspect-video overflow-hidden bg-aura-accent rounded-xl" data-testid={`live-session-${s.id}`}>
              {s.products?.[0] && (
                <img src={imgUrl(s.products[0].images?.[0])} alt={s.title} className="w-full h-full object-cover img-zoom opacity-70" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-aura-bg via-aura-bg/30 to-transparent" />
              <div className="absolute top-4 left-4 flex items-center gap-2">
                <span className="neon-live rounded-full bg-aura-accent text-white text-[10px] font-semibold tracking-luxe uppercase px-3 py-1 flex items-center gap-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-white dot-blink" /> Live
                </span>
                <span className="neon-count rounded-full glass-dark text-white text-[10px] px-2.5 py-1 flex items-center gap-1.5 border"><Users className="w-3 h-3 text-aura-cyan" /> {s.viewer_count}</span>
              </div>
              <div className="absolute bottom-5 left-5 right-5 text-white">
                <div className="text-xs text-white/70 mb-1">{s.seller_name}</div>
                <div className="font-serif text-2xl leading-tight">{s.title}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
